import React from 'react'

import { useFetch } from 'hooks'
import type { InterviewTemplateResponse } from '../types'

// NOTE: hook that exposes server data for other
// local hooks and interview templates creator
// components
export const useData = (state, handlers) => {
  const { uuid } = state
  const { handleFetchTemplates } = handlers

  const handleFetch = React.useCallback(
    async () => await handleFetchTemplates({ uuid }),
    [uuid, handleFetchTemplates],
  )

  const {
    state: { error, meta, response, isFetching },
    handlers: { handleRefetch, handleSetResponse },
  } = useFetch<InterviewTemplateResponse>(handleFetch)

  return {
    state: {
      error,
      meta,
      response,
      isFetching,
    },
    handlers: {
      handleRefetch,
      handleSetResponse,
    },
  }
}
